
import React, { useEffect, useState } from 'react';
import { supabase, isSupabaseConfigured } from '../../lib/supabase';
import { UserRole } from '../../types';
import { Shield, User, Database, Activity, Briefcase } from 'lucide-react';
import AdminUsers from './AdminUsers';
import AdminCatalog from './AdminCatalog';
import AuditLogs from './AuditLogs';
import AdminProjects from './AdminProjects';

type Tab = 'users' | 'projects' | 'catalog' | 'audit';

const AdminPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>(() => {
      const savedTab = localStorage.getItem('sil_admin_tab');
      return (savedTab as Tab) || 'users';
  });

  const [currentUserRole, setCurrentUserRole] = useState<UserRole>('technician');

  useEffect(() => {
    if (isSupabaseConfigured()) {
        supabase.auth.getUser().then(({data}) => {
            if (data.user) {
                supabase.from('profiles').select('role').eq('id', data.user.id).single()
                  .then(({data: prof}) => prof && setCurrentUserRole(prof.role as UserRole));
            }
        });
    } else { setCurrentUserRole('admin'); }
  }, []);

  const handleTabChange = (tab: Tab) => {
      setActiveTab(tab);
      localStorage.setItem('sil_admin_tab', tab);
  };

  if (currentUserRole !== 'admin') {
      return (
          <div className="flex flex-col items-center justify-center h-full text-center p-8">
              <div className="bg-red-50 p-4 rounded-full mb-4"><Shield size={48} className="text-red-500" /></div>
              <h2 className="text-xl font-bold text-slate-800">Accès Refusé</h2>
          </div>
      );
  }

  return (
    <div className="flex flex-col h-full overflow-hidden">
      
      {/* HEADER ADMIN FIXE */}
      <div className="p-4 md:p-8 pb-0 shrink-0 border-b border-slate-200 bg-slate-100 z-20 shadow-sm">
        <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2 mb-6">
          <Shield size={24} className="text-indigo-600"/> Administration
        </h2>

        <div className="flex gap-6 overflow-x-auto scrollbar-hide">
            <TabBtn active={activeTab === 'users'} onClick={() => handleTabChange('users')} icon={User} label="Utilisateurs" />
            <TabBtn active={activeTab === 'projects'} onClick={() => handleTabChange('projects')} icon={Briefcase} label="Projets" />
            <TabBtn active={activeTab === 'catalog'} onClick={() => handleTabChange('catalog')} icon={Database} label="Catalogue" />
            <TabBtn active={activeTab === 'audit'} onClick={() => handleTabChange('audit')} icon={Activity} label="Audit & Logs" />
        </div>
      </div>

      {/* CONTENU ACTIF (Gère son propre scroll via le tableau standardisé) */}
      <div className="flex-1 overflow-hidden flex flex-col">
        {activeTab === 'users' && <AdminUsers />}
        {activeTab === 'projects' && <AdminProjects />}
        {activeTab === 'catalog' && <AdminCatalog />}
        {activeTab === 'audit' && <AuditLogs />}
      </div>
    </div>
  );
};

const TabBtn = ({ active, onClick, icon: Icon, label }: any) => (
    <button onClick={onClick} className={`pb-3 border-b-2 transition-colors flex items-center gap-2 whitespace-nowrap text-sm font-medium ${active ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
        <Icon size={16} /> {label}
    </button>
);

export default AdminPanel;
